import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fetch } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../components/Button'
import Loader from '../../../../components/Loader'
import Pagination from '../../../../components/Pagination'
import Table from '../../../../components/Table'
import routes from '../../../../config/routes'
import RealtyType, { STATUS } from '../../../../models/Realty'
import CardColors from '../../CardColors'
import PageContent from '../../PageContent'
import PageHeader from '../../PageHeader'
import Filter from './Filter'
import { Container } from './styles'

interface Props {

}

const RealtyListScreen: React.FC<Props> = () => {
  const cacheParams = JSON.parse(localStorage.getItem('realty_list_params') || '{}')
  const defaultApiUrl = `${process.env.REACT_APP_API_URL}/realties`
  const [apiUrl, setApiUrl] = useState(localStorage.getItem('realty_list_api_url') || defaultApiUrl)
  const [params, setParams] = useState<any>(cacheParams || {})
  const history = useHistory()

  useEffect(() => {
    localStorage.setItem('realty_list_api_url', apiUrl)
    localStorage.setItem('realty_list_params', JSON.stringify(params))
  }, [params, apiUrl])

  function getPrintUrl(): string {
    const queryString = Object.keys(params).map((key) => {

      if(params[key])
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
      else
        return ''

    }).join('&')

    return `${process.env.REACT_APP_API_URL}/realties/export/pdf?${queryString}`
  }

  return (
    <div>
      <PageHeader
        title="Imóveis"
        subtitle="Lista de imóveis"
      />
      <PageContent>
        <Fetch
          url={`${process.env.REACT_APP_API_URL}/dashboard`}
        >
          {({ data }) => data && data.data && (
            <CardColors
              data={[
                {
                  color: '#3c5499',
                  label: 'Total de imóveis',
                  content: data.data.imoveis.total.toString(),
                },
                {
                  color: '#fb8c00',
                  label: 'Pendentes de análise',
                  content: data.data.imoveis.pendentesAnalise.toString(),
                },
                {
                  color: '#ff4f70',
                  label: 'Propostas feitas',
                  content: data.data.imoveis.propostasFeitas.toString(),
                },
                {
                  color: '#22ca80',
                  label: 'Propostas aceitas',
                  content: data.data.imoveis.propostasAceitas.toString(),
                },
              ]}
            />
          )}
        </Fetch>
        <Filter
          initialParams={params}
          onChange={(newParams) => {
            setApiUrl(defaultApiUrl)
            setParams(newParams)
          }}
        />
        <Container
          style={{ marginBottom: '10px', justifyContent: 'flex-end' }}
        >
          <Button
            before={<FontAwesomeIcon
              icon={faPrint}
            />}
            label=""
            backgroundColor="transparent"
            fontColor="darkBlue"
            onClick={() => {
              Axios({
                url: getPrintUrl(),
                method: 'GET',
                responseType: 'blob', // important
              }).then((response: any) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Imóveis.pdf')
                document.body.appendChild(link)
                link.click()
              })
            }}
          />

        </Container>
        <Fetch
          url={apiUrl}
          params={params}
          loader={() => (
            <Loader
              darkMode
            />
          )}
        >
          {({ data }) => data && data.data ? (
            <Container>
              {data.data.length ? (
                <>
                  <Table
                    header={[
                      'ID',
                      'Matrícula',
                      'Informação fiscal',
                      'Tipo',
                      'Endereço',
                      'Atrasado desde',
                      'Status',
                    ]}
                    items={data.data.map((realty: RealtyType) => [
                      realty.id,
                      realty.registration_number,
                      realty.fiscal_information,
                      `${realty.type} ${realty.custom_type ? `- ${realty.custom_type}` : ''}`,
                      realty.address ? `${realty.address.street}, ${realty.address.number} - ${realty.address.complement} - ${realty.address.neighborhood} - ${realty.address.city} - ${realty.address.state}` : '-',
                      realty.owes_since,
                      STATUS[realty.status],
                    ])}
                    onClick={item => {
                      history.push(
                        routes.admin.realty.show.pathFor(parseInt(item[0], 10)),
                      )
                    }}
                  />

                  <Pagination
                    meta={data.meta}
                    links={data.links}
                    onChange={setApiUrl}
                  />
                </>
              ) : (
                <span>Nenhum resultado encontrado</span>
              )}
            </Container>
          ) : (
            <span>
                Error
            </span>
          )}
        </Fetch>
      </PageContent>
    </div >
  )
}

export default RealtyListScreen
